export const COMMON_API_URLS = {
  REVERSE_GEOCODE:
    '/api/location/reverse-geocode?latitude=#{latitude}&longitude=#{longitude}'
} as const;
